import React from 'react';
import StatusBadge from './StatusBadge';

function TimelineView({ filteredData, setSelectedState }) {
  // Sort by effective date
  const timelineData = [...filteredData].sort((a, b) => {
    const dateA = new Date(a.effectiveDate);
    const dateB = new Date(b.effectiveDate);
    return dateA - dateB;
  });

  // Group by year and quarter
  const groupedData = timelineData.reduce((acc, item) => {
    const date = new Date(item.effectiveDate);
    const year = date.getFullYear() || 'Unknown';
    const month = date.getMonth();

    let quarter;
    if (isNaN(month)) {
      quarter = 'Unknown';
    } else if (month < 3) {
      quarter = 'Q1';
    } else if (month < 6) {
      quarter = 'Q2';
    } else if (month < 9) {
      quarter = 'Q3';
    } else {
      quarter = 'Q4';
    }

    const key = `${year}-${quarter}`;

    if (!acc[key]) {
      acc[key] = {
        year,
        quarter,
        items: []
      };
    }

    acc[key].items.push(item);
    return acc;
  }, {});

  const sortedGroups = Object.values(groupedData).sort((a, b) => {
    if (a.year !== b.year) return a.year - b.year;
    return a.quarter.localeCompare(b.quarter);
  });

  if (timelineData.length === 0) {
    return (
      <div className="text-center py-12">
        <i className="fas fa-calendar-times text-6xl text-gray-300 mb-4"></i>
        <h3 className="text-xl font-semibold text-gray-600 mb-2">No timeline data</h3>
        <p className="text-gray-500">Try adjusting your filters</p>
      </div>
    );
  }

  return (
    <div className="space-y-8">
      {sortedGroups.map((group, groupIdx) => (
        <div key={groupIdx}>
          {/* Period Header */}
          <div className="flex items-center mb-4">
            <div className="bg-gradient-to-r from-purple-600 to-purple-400 text-white px-4 py-2 rounded-lg font-bold">
              {group.year} {group.quarter !== 'Unknown' ? group.quarter : ''}
            </div>
            <div className="flex-1 h-0.5 bg-gradient-to-r from-purple-400 to-transparent ml-4"></div>
            <span className="ml-4 text-sm text-gray-500 font-medium">
              {group.items.length} {group.items.length === 1 ? 'law' : 'laws'}
            </span>
          </div>

          {/* Timeline Items */}
          <div className="space-y-4">
            {group.items.map((state, idx) => (
              <div key={idx} className="timeline-item">
                <div className="timeline-dot"></div>
                <div
                  className="bg-white rounded-lg shadow-md p-4 ml-4 card-hover cursor-pointer"
                  onClick={() => setSelectedState(state)}
                >
                  <div className="flex justify-between items-start mb-2">
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-1">
                        <h4 className="font-bold text-gray-900">{state.state || state.country}</h4>
                        <span className="px-2 py-0.5 bg-purple-100 text-purple-700 rounded text-xs font-medium">
                          {state.category}
                        </span>
                      </div>
                      <p className="text-sm text-gray-600">{state.lawName}</p>
                    </div>
                    <StatusBadge status={state.status} />
                  </div>
                  <div className="text-sm text-gray-500">
                    <i className="fas fa-calendar-alt mr-2 text-purple-600"></i>
                    {state.effectiveDate}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default TimelineView;
